import { useState } from 'react';

export const useExponentReRender = (
  maxLimit: number,
): [boolean, () => void, number, boolean] => {
  const [exponentRetryTimes, setExponentRetryTimes] = useState(0);
  const [shouldMount, setShouldMount] = useState(true);
  const isExceeded = exponentRetryTimes >= maxLimit;
  const exponentReMount = () => {
    if (isExceeded) {
      return;
    }
    setTimeout(() => {
      setExponentRetryTimes(exponentRetryTimes + 1);
      setShouldMount(false);
      setShouldMount(true);
    }, (exponentRetryTimes + 2) * 1000);
  };

  return [shouldMount, exponentReMount, exponentRetryTimes, isExceeded];
};
